import { InsertDriveFile } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import React from 'react';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const FileSelectorBtn = ({ select, fileInputRef,fileSelectorError }) => {
  return (
    <React.Fragment>
      <Button
        variant={fileSelectorError?"outlined":"contained"}
        startIcon={<InsertDriveFile />}
        onClick={() => {
          fileInputRef.current.click();
        }}
        sx={{
          color: `${themeColors.ColorSecondary} !important`,
          backgroundColor: fileSelectorError ? 'red !important' : `${themeColors.ColorPrimary} !important`,        }}
      >
        {select}
      </Button>
    </React.Fragment>
  );
};

export default FileSelectorBtn;
